export default "__VITE_ASSET__9fac8e10__"